import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonSizeEnum } from '../base-button/base-button-size.enum';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss']
})
export class DashboardHeaderComponent {
  @Input() title: string = '';
  @Output() rearrangeButtonClicked = new EventEmitter();
  @Output() testCreditCardClicked = new EventEmitter();

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
  protected readonly environment = environment;
}
